/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module DiscordTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface DiscordPlugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `DiscordPlugin`'s JSON-Schema
 * via the `definition` "UpdatePresenceParameters".
 */
export interface UpdatePresenceParameters {
    /**
     * what the player is currently doing
     */
    details?: string;
    /**
     * current party status
     */
    state?: string;
    /**
     * epoch seconds for game start to show time as elapsed
     */
    startTimestamp?: number;
    largeImageKey?: DiscordAsset;
    /**
     * tooltip for the largeImageKey
     */
    largeImageText?: string;
    smallImageKey?: DiscordAsset;
    /**
     * tooltip for the smallImageKey
     */
    smallImageText?: string;
    /**
     * Array of buttons to display (max 2)
     */
    buttons?: {
        /**
         * Button label text
         */
        label: string;
        /**
         * URL to open when button is clicked
         */
        url: string;
    }[];
}

/**
 * Asset keys defined in Discord Dev Portal
 *
 * This interface was referenced by `DiscordPlugin`'s JSON-Schema
 * via the `definition` "DiscordAsset".
 */
export enum DiscordAsset {
    Large = 0
}


}
